import { FoodItem } from '../types/nutrition';

export const searchableFoods: FoodItem[] = [
  {
    id: 'chicken-breast',
    name: "Chicken Breast",
    calories: 165,
    protein: 31,
    carbs: 0,
    fat: 3.6,
    emoji: "🍗",
    serving: "100g",
    image: "https://images.unsplash.com/photo-1632778149955-e80f8ceca2e8?w=800&q=80"
  },
  {
    id: 'salmon-fillet',
    name: "Salmon Fillet",
    calories: 208,
    protein: 22,
    carbs: 0,
    fat: 13,
    emoji: "🐟",
    serving: "100g",
    image: "https://images.unsplash.com/photo-1599084993091-1cb5c0721cc6?w=800&q=80"
  },
  {
    id: 'brown-rice',
    name: "Brown Rice",
    calories: 111,
    protein: 2.6,
    carbs: 23,
    fat: 0.9,
    emoji: "🍚",
    serving: "100g cooked",
    image: "https://images.unsplash.com/photo-1536304993881-ff6e9eefa2a6?w=800&q=80"
  },
  {
    id: 'sweet-potato',
    name: "Sweet Potato",
    calories: 86,
    protein: 1.6,
    carbs: 20,
    fat: 0.1,
    emoji: "🍠",
    serving: "100g",
    image: "https://images.unsplash.com/photo-1596097635121-14b63b37cb30?w=800&q=80"
  },
  {
    id: 'greek-yogurt',
    name: "Greek Yogurt",
    calories: 59,
    protein: 10,
    carbs: 3.6,
    fat: 0.4,
    emoji: "🥛",
    serving: "100g",
    image: "https://images.unsplash.com/photo-1488477181946-6428a0291777?w=800&q=80"
  },
  {
    id: 'banana',
    name: "Banana",
    calories: 89,
    protein: 1.1,
    carbs: 23,
    fat: 0.3,
    emoji: "🍌",
    serving: "1 medium (118g)",
    image: "https://images.unsplash.com/photo-1571771894821-ce9b6c11b08e?w=800&q=80"
  },
  {
    id: 'almonds',
    name: "Almonds",
    calories: 164,
    protein: 6,
    carbs: 6,
    fat: 14,
    emoji: "🥜",
    serving: "28g (1oz)",
    image: "https://images.unsplash.com/photo-1508061253366-f7da158b6d46?w=800&q=80"
  },
  {
    id: 'avocado',
    name: "Avocado",
    calories: 160,
    protein: 2,
    carbs: 8.5,
    fat: 14.7,
    emoji: "🥑",
    serving: "100g",
    image: "https://images.unsplash.com/photo-1523049673857-eb18f1d7b578?w=800&q=80"
  },
  {
    id: 'oatmeal',
    name: "Oatmeal",
    calories: 307,
    protein: 13,
    carbs: 55,
    fat: 5,
    emoji: "🥣",
    serving: "100g dry",
    image: "https://images.unsplash.com/photo-1517673400267-0251440c45dc?w=800&q=80"
  },
  {
    id: 'eggs',
    name: "Eggs",
    calories: 155,
    protein: 13,
    carbs: 1.1,
    fat: 11,
    emoji: "🥚",
    serving: "100g (2 large eggs)",
    image: "https://images.unsplash.com/photo-1506976785307-8732e854ad03?w=800&q=80"
  }
];